import React from 'react';
import { Stack } from '@mui/material';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import ScheduleTable from 'src/features/PortDetail/Operation/ScheduleTable';
import OperatorsTable from 'src/features/PortDetail/Operation/OperatorsTable';
import PortcallDelayTable from 'src/features/PortDetail/Operation/PortcallDelayTable';

// Utilities
import { ITradePortDetailInfo } from 'src/utils/typings/response';

interface IProps {
  portDetail: ITradePortDetailInfo | null;
}

const OperationTab = ({ portDetail }: IProps) => {
  return (
    <React.Fragment>
      <Stack direction="column" spacing={3}>
        <Stack direction="column" spacing={3}>
          {/* <ScheduleTable
            listAllSchedules={getArrayDefault(portDetail?.schedules)}
            scheduleStats={portDetail?.schedule_stats}
          /> */}
          <OperatorsTable listAllOperators={getArrayDefault(portDetail?.operator)} />
          <PortcallDelayTable
            listAllDelayStats={getArrayDefault(portDetail?.delay_stats)}
            locode={portDetail?.meta?.locode || ''}
          />
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default OperationTab;
